<template>
  <div class="page-wrapper">
    <div class="page-body">
      <div class="wrapper">
        <editorComponents :account_type="account_type" v-model="isComponentMinimized"
          :class="{ minimized: isComponentMinimized }">

          <template v-slot:body>
            <CvsList :account_type="account_type" :templateAllowedVersion="templateAllowedVersion"
              @createTemplate="createNewTemplate" @previewPdf="previewPdf" @previewCv="previewCv"
              @previewTemplate="previewTemplate"></CvsList>
          </template>
        </editorComponents>

        <div class="section-spacer"></div>

        <div class="editor-section" :class="{ canScroll: preview_type != 'pdf' }" :style="{
          width: `calc(100% - ${previewSectionWidth}px)`,
        }">

          <!-- Preview Interna CV or Template -->
          <div v-if="preview_type == 'cv' && isPreviewing || preview_type == 'template' && isPreviewing"
            class="cv-template-page-wrapper">

            <div class="cv-page-container" v-for="(page, pageIndex) in layers" :key="pageIndex">
              <div class="cv-template-page" :id="page.itemId" :layer-level="0" :layer-index="pageIndex"
                :layer-type="page.itemType" layer-parent-type="none" :layer-parent-index="null"
                :layer-index-path="JSON.stringify([pageIndex])">

                <template v-for="(item, index) in page.children">
                  <template v-if="item.itemType == 'container_element' && item.dataOrigin != '' && !isApplyingProfile">
                    <EditorTemplateElementViewer v-for="(n, j) in item.numberOfItems" :key="'goust_' + j + n"
                      :layer="item" @selectElement="() => {
                        item.itemSelected = true;
                      }" :itemLayerIndex="index" :itemLayerLever="1" :isGuostItem="j > 0"
                      :GuostItemIndex="item.dataStartAt + j - 1" :itemParentLayerType="page.itemType"
                      :itemLayerIndexPath="[pageIndex]" :readonly="true">
                    </EditorTemplateElementViewer>
                  </template>
                  <EditorTemplateElementViewer v-else :key="index" :layer="item" @selectElement="() => {
                    item.itemSelected = true;
                  }" :itemLayerIndex="index" :itemLayerLever="1" :itemParentLayerType="page.itemType"
                    :itemLayerIndexPath="[pageIndex]" :readonly="true" :isApplyingProfile="isApplyingProfile">
                  </EditorTemplateElementViewer>
                </template>
              </div>
            </div>
          </div>
          <!-- Preview pdf -->
          <div v-if="preview_type == 'pdf' && isPreviewing" class="pdf-previewer">
            <object :data="preview_pdf_url" type="application/pdf" width="100%" height="100%"></object>
          </div>
          <!-- Preview Section -->
          <div class="preview-widget" v-if="!isPreviewing">
            <h1>Select CV or Template to preview</h1>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { SITE_API, ACCOUNT_TYPE, FILE_MAKER_SERVER_BASE_URL } from "@/Store/variable.js";
import editorComponents from "./components/editor_components.vue";
import CvsList from "./components/editor_cvs_list.vue";
import ProfileSelection from "./profiles_cvs/profile_selection.vue";
import EditorTemplateElementViewer from "./components/editor_template_element_viewer.vue";

export default {
  components: {
    ProfileSelection,
    editorComponents,
    CvsList,
    EditorTemplateElementViewer
  },
  props: {
    templateAllowedVersion: {
      type: String,
      default: "1.3"
    }
  },
  data: function () {
    return {
      SITE_API_URL: SITE_API,
      isComponentMinimized: false,
      isProfileMinimized: false,
      account_type: ACCOUNT_TYPE,
      isPreviewing: false,
      preview_pdf_url: "",
      preview_type: "cv",
      is_loading: false,
      layers: [],
      active_template_version: 'default',
      isApplyingProfile: true
    };
  },
  mounted() {
    let vm = this;
    window.addEventListener("gesturestart", function (e) {
      e.preventDefault();
    });

    window.addEventListener("gesturechange", function (e) {
      e.preventDefault();
    });

    window.addEventListener("gestureend", function (e) {
      e.preventDefault();
    });
  },
  watch: {
  },
  computed: {
    previewSectionWidth() {
      let vm = this;
      if (vm.account_type == 'school') {
        if (vm.isProfileMinimized) {
          return -150 + (vm.isComponentMinimized ? 50 : 200);
        } else {
          return 200 + (vm.isComponentMinimized ? 50 : 200);
        }
      } else {
        if (vm.isComponentMinimized) {
          return 50;
        } else {
          return 230;
        }
      }
    },
  },
  methods: {
    previewPdf({ url }) {
      let vm = this;
      vm.preview_type = "pdf";
      vm.preview_pdf_url = url;
      vm.isPreviewing = true;
    },
    previewCv(item, canDownload = false) {
      let vm = this;
      const cvData = JSON.parse(item.cvData);
      if (cvData.version == vm.templateAllowedVersion) {
        vm.isPreviewing = true;
        vm.isApplyingProfile = true;
        vm.layers = cvData.cvData;
        vm.preview_type = "cv";
        if (canDownload) {
          setTimeout(() => {
            vm.downloadCv();
          }, 500);
        }
      } else {
        vm.$notify({
          group: "status",
          title: "Message",
          text: "This CV is not supported.",
          type: "warn",
          duration: 3000,
        });
      }
    },
    previewTemplate(item) {
      let vm = this;

      const templateData = JSON.parse(item.cvData);
      if (templateData.version == vm.templateAllowedVersion) {
        vm.layers = templateData[vm.active_template_version];
        vm.isPreviewing = true;
        vm.isApplyingProfile = false;
        vm.preview_type = "template";
      } else {
        vm.$notify({
          group: "status",
          title: "Message",
          text: "This template is not supported.",
          type: "warn",
          duration: 3000,
        });
      }
    },
    createNewTemplate(payload) {
      let vm = this;
      vm.$emit('switchSection', 2, payload);
    },
    applyEffectToElementAndChildren(element) {
      let vm = this;
      // check if element is not svg
      if (element.tagName !== 'svg') {
        const attributes = element.getAttributeNames();
        for (const attribute of attributes) {
          if (attribute !== 'style' && attribute !== 'src') {
            element.removeAttribute(attribute);
          }
        }
        const children = element.children;
        for (const child of children) {
          vm.applyEffectToElementAndChildren(child);
        }
      }
    },
    downloadCv() {
      let vm = this;
      vm.loadingDownloadingCv = true;
      vm.$store.commit("SET_DOWNLOADING_CV", true);
      const pageDom = vm.layers.map((item, index) => {
        let parentPageEl = document.querySelector(`#${item.itemId}`).parentNode.cloneNode(true);
        let pageEl = parentPageEl.querySelector(`#${item.itemId}`);
        vm.applyEffectToElementAndChildren(pageEl);
        pageEl.style.removeProperty("width");
        pageEl.style.removeProperty("height");
        pageEl.classList.add("cv-template-page");
        return {
          index: index,
          page: pageEl.parentElement.innerHTML.replaceAll('<!---->', "")
        }
      });
      vm.$store
        .dispatch("CVS_GENELATE_FILE", {
          pages: pageDom,
        })
        .then((response) => {
          vm.loadingDownloadingCv = false;
          vm.$store.commit("SET_DOWNLOADING_CV", false);
          const url = FILE_MAKER_SERVER_BASE_URL + "/download/" + response.data.url;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "cv.pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.loadingDownloadingCv = false;
          vm.$store.commit("SET_DOWNLOADING_CV", false);
        });
    },
  }
};
</script>


<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Fredoka:wght@300;400;500;600;700&family=Hubballi&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=League+Gothic&family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Syne+Mono&display=swap");
</style>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  background: #ebebeb;
  padding: 5px;
  height: 100%;


  .page-body {
    height: 100%;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    transition: 500ms ease-in-out;




    .wrapper {
      height: 100%;
      width: 100%;
      display: flex;

      .section-spacer {
        margin-right: 5px;
      }

      .editor-section {
        transition: 500ms ease-in-out;
        height: 100%;
        width: calc(100% - 460px);
        display: flex;
        flex-direction: column;
        border: 2px dashed #ddd;
        background: #eeeeee;
        border-radius: 5px;
        position: relative;
        overflow: hidden;

        &.canScroll {
          overflow-y: auto !important;
        }

        .cv-template-page-wrapper {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          zoom: 1;
          padding: 50px 0px;

          .cv-page-container {
            height: 842px;
            width: 595px;
            background: #fff;
            position: relative;
            margin-bottom: 30px;

            .cv-template-page {
              position: relative;
              background: #fff;
              width: 595px;
              height: 842px;
              transform-origin: 0 0;
              transform: var(--normal-zoom);
            }
          }
        }


        .cv-previewer {
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 100%;
          background: #eeeeee;
          border-radius: 5px;
        }

        .pdf-previewer {
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 100%;
          background: #eeeeee;
          border-radius: 5px;
        }

        .preview-widget {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          width: 100%;
          background: #eeeeee;
          border-radius: 5px;

          h1 {
            color: #acacac;
            font-size: 13px;
          }
        }
      }
    }
  }

  .pages-widget {
    display: block;
    padding-top: 20px;
    background: #dbdbdb;
    border: 1px solid #ddd;

    .page {
      margin: 0 auto;
      width: 595px;
      height: 842px;
      margin-bottom: 30px;
      background: #ffffff;

      img.image-preview {
        width: 595px;
        height: 842px;
        object-fit: contain;
      }
    }
  }

  .warning-body-widget {
    padding-top: 20px;

    .warning-title {
      color: #a51b1b;
    }
  }
}
</style>
